import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";

export default function CategoryStrip() {
  return (
    <section aria-labelledby="cat-strip-title" className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
      <h2 id="cat-strip-title" className="font-heading text-2xl font-bold text-foreground-950 mb-2">
        六大现场分类，按你关心的方式看
      </h2>
      <p className="max-w-3xl text-sm leading-relaxed text-foreground-600 mb-8">
        同一件事，不同机位能看出完全不同的信息。我们把内容拆成六类：想要临场感就去「第一现场」，
        想补全细节就看「完整版」，想提前一睹为快就翻「路透」。
      </p>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat, index) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex cursor-pointer items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
          >
            <span
              className={`inline-flex items-center justify-center w-11 h-11 flex-shrink-0 rounded-md ${
                index % 2 === 0 ? "bg-primary-100 text-primary-600" : "bg-accent-100 text-accent-700"
              }`}
            >
              <i className={`${cat.icon} w-5 h-5 flex items-center justify-center`}></i>
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-1.5 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {cat.name}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100"></i>
              </span>
              <span className="mt-1.5 block text-xs leading-relaxed text-foreground-600">{cat.description}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}